import { ApplicationSetting } from '@app/core/model/enums/application-setting.enum'
import { Privilege } from '@app/core/model/enums/privilege.enum'
import { ScopeVersion } from '@app/core/model/scope-version'
import { User } from '@app/core/model/user.model'

export function hasFixedCostDeliverableEditPrivileges(user: User, scope: ScopeVersion): boolean {
  if (!user) return false

  if (scope.identity.isTemplate) return user.hasPrivilege(Privilege.SCOPE_TEMPLATE__EDIT)

  return (
    user.hasPrivilege(Privilege.SCOPE_FIXED_COST_DELIVERABLE__EDIT) &&
    user.company.hasApplicationSetting(ApplicationSetting.SCOPE__FIXED_COST_DELIVERABLE_EDITING)
  )
}

export function hasFixedCostComponentEditPrivileges(user: User, scope: ScopeVersion): boolean {
  if (!user) return false

  if (scope.identity.isTemplate) return user.hasPrivilege(Privilege.SCOPE_TEMPLATE__EDIT)

  return user.hasPrivilege(Privilege.SCOPE_FIXED_COST_COMPONENT__EDIT)
}
